import { useMemo } from 'react';
import { Flex, Text } from '@distribusion/portal-lib/components';
import { ALL_CURRENCY_OPTIONS, CurrencyEnum } from '@distribusion/portal-lib/constants';
import { getCurrencySymbol } from '@distribusion/portal-lib/utils';

export const useCurrencyOptions = (currencies?: CurrencyEnum[]) => {
  return useMemo(
    () =>
      (currencies || ALL_CURRENCY_OPTIONS).sort().map((currency) => ({
        label: (
          <Flex justify="space-between" gap="small" style={{ minWidth: '100px' }}>
            <Text>{currency}</Text>
            <Text>{getCurrencySymbol(currency)}</Text>
          </Flex>
        ),
        key: currency,
        value: currency,
      })),
    [currencies],
  );
};
